@if(categoryPoints){
    <div class="row row-cols-2 g-2 mx-0 mt-1">
        <ng-content></ng-content>
        <!-- played -->
        <div class="col">
          <div class="card h-100 {{getBorderClass(categoryPoints.result)}}">
            <div class="card-header border-bottom-0 {{getBackgroundClass(categoryPoints.result)}}">
                <span>wed. punten</span>
                <span class="badge bg-points float-end ms-1">{{categoryPoints.result}}</span>
            </div>
            <div class="card-body">
                <div>
                    <span [class]="{'text-decoration-line-through': !statistics().isStarting()}">basis</span>
                </div>
                <div>
                    <span [class]="{'text-decoration-line-through': !statistics().isSubstitute()}">ingevallen</span>
                    @if(statistics().isSubstitute()) {
                        <span class="float-end ms-1">{{statistics().getBeginMinute()}}"</span>
                    }
                </div>
                <div>
                    <span [class]="{'text-decoration-line-through': statistics().hasAppeared()}">bank</span>
                </div>
                <div>
                    <span [class]="{'text-decoration-line-through': !statistics().isSubstituted()}">gewisseld</span>
                    @if(statistics().isSubstituted()) {
                        <span class="float-end ms-1">{{statistics().getEndMinute()}}"</span>
                    }
                </div>
            </div>
                    </div>
        </div>
        <!-- goals -->
                <div class="col">
                    <div class="card h-100 {{getBorderClass(categoryPoints.goal)}}">
            <div class="card-header border-bottom-0 {{getBackgroundClass(categoryPoints.goal)}}">
                <span>goals</span>
                @if(categoryPoints.goalHasStats) {
                    <span 
                        class="badge float-end ms-1"
                        [class]="categoryPoints.goalHasStats ? 'bg-points' : 'bg-nostats'"
                    >{{categoryPoints.goal}}</span>
                }
                
            </div>
            <div class="card-body">
                <div>
                    <app-superelf-icon [icon]=faFutbol [gameEvent]="Goal"></app-superelf-icon>                
                    <span class="ms-1">veld</span>
                    @if(statistics().getNrOfFieldGoals() > 0) {
                        <span class="float-end ms-1">{{statistics().getNrOfFieldGoals()}}x</span>
                    } @else {
                        <span class="float-end ms-1">-</span>
                    }
                </div>
                <div>          
                    <fa-icon [icon]=faHandshakeAngle></fa-icon>          
                    <span class="ms-1">assist</span>
                    @if(statistics().getNrOfAssists() > 0) {
                        <span class="float-end ms-1">{{statistics().getNrOfAssists()}}x</span>
                    } @else {
                        <span class="float-end ms-1">-</span>
                    }                    
                </div>
                <div>
                    <app-superelf-icon [icon]=faFutbol [gameEvent]="OwnGoal"></app-superelf-icon>                
                    <span class="ms-1">eigen</span>
                    @if(statistics().getNrOfOwnGoals() > 0) {
                        <span class="float-end ms-1">{{statistics().getNrOfOwnGoals()}}x</span>
                    } @else {
                        <span class="float-end ms-1">-</span>
                    }
                </div>
                <div>
                    <app-superelf-icon [icon]=facPenalty></app-superelf-icon>
                    <span class="ms-1">penalty</span>
                    @if(statistics().getNrOfPenalties() > 0) {
                        <span class="float-end ms-1">{{statistics().getNrOfPenalties()}}x</span>
                    } @else {
                        <span class="float-end ms-1">-</span>
                    }
                </div>
            </div>
          </div>
        </div>
        <!-- defense -->
        @if(sheetActive) {
          <div class="col">
            <div class="card h-100 {{getBorderClass(categoryPoints.sheet)}}">
                <div class="card-header border-bottom-0 {{getBackgroundClass(categoryPoints.sheet)}}">
                    <span>tegengoals</span>
                    @if(categoryPoints.sheetHasStats) {
                        <span 
                            class="badge float-end ms-1"
                            [class]="categoryPoints.sheetHasStats ? 'bg-points' : 'bg-nostats'"
                        >{{categoryPoints.sheet}}</span>
                    }
                </div>
                <div class="card-body">
                    <div>
                        <app-superelf-icon [icon]=facCleanSheet></app-superelf-icon>
                        <span class="ms-1">de nul</span>
                        @if(statistics().hasCleanSheet()) {
                            <fa-icon [icon]=faCheckCircle class="float-end ms-1 text-success"></fa-icon>
                        } @else {
                            <span class="float-end ms-1">-</span>
                        }
                    </div>

                    <div>
                        <app-superelf-icon class="me-1" [icon]=facSpottySheet></app-superelf-icon>
                        <span>&gt; 3</span>
                        @if(statistics().hasSpottySheet()) {
                            <fa-icon [icon]=faCheckCircle class="float-end ms-1 text-success"></fa-icon>
                        } @else {
                            <span class="float-end ms-1">-</span>
                        }
                    </div>
                </div>
            </div>
                    </div>
        }
        <!-- cards -->
                <div class="col">
                    <div class="card h-100 {{getBorderClass(categoryPoints.card)}}">
            <div class="card-header border-bottom-0 {{getBackgroundClass(categoryPoints.card)}}">
                <span>kaarten</span>
                @if(categoryPoints.cardHasStats) {
                    <span 
                        class="badge float-end ms-1"
                        [class]="categoryPoints.cardHasStats ? 'bg-points' : 'bg-nostats'"
                    >{{categoryPoints.card}}</span>                
                }
                
            </div>
            <div class="card-body">
                <div>
                    <app-superelf-icon [icon]=facCard [gameEvent]="YellowCard"></app-superelf-icon>
                    <span class="mx-1">geel</span>
                    @if(statistics().getNrOfYellowCards() > 0) {
                        <span class="float-end ms-1">{{statistics().getNrOfYellowCards()}}x</span>
                    }
                    @if (statistics().getNrOfYellowCards() === 0) {
                        <span class="float-end ms-1">-</span>
                    }
                </div>
                <div>
                    <app-superelf-icon [icon]=facCard [gameEvent]="RedCard"></app-superelf-icon>
                    <span class="mx-1">rood</span>
                    @if(statistics().gotDirectRedCard()) {
                        <fa-icon [icon]=faCheckCircle class="float-end ms-1 text-red"></fa-icon>
                    } @else {
                        <span class="float-end ms-1">-</span>
                    }
                </div>
            </div>
          </div>
        </div>
    </div>
}